<template>
<div class="card-body">
  <h5 class="card-title">{{ route.duration | durationFormat }}</h5>
  <div class="d-flex justify-content-between bd-highlight mb-3">
    <p>{{ route.startTime | epoch2TimeFormat }} - {{ route.endTime | epoch2TimeFormat }}</p>
    <p>
    <span class="icon-icon-walk"></span>
    {{ route.walk_duration.value | durationFormat }}
    <!-- {{ route.walkTime | durationFormat }} -->
    </p>
  </div>
  <div class="mode-icons">
    <span v-for="(leg, legIndex) in route.legs"
         :key="legIndex"
         class="mode-icons mode-icons-icon mr-2">
      <div class="mode-details" :class="{ 'mode-walk' : leg.mode === 'WALK' }" @click.stop="viewRouteDetails(leg.mode, leg.routeShortName)">
        <span v-if="leg.modeIcon" :class="leg.modeIcon.class"></span>
        <span v-else>{{ leg.mode }}</span>
        <span class="line-no" v-if="leg.routeShortName">{{ leg.routeShortName }}</span>
      </div>
      <span class="icon-icon-triangle-right ml-2" v-if="legIndex < route.legs.length-1"></span>
    </span>
  </div>
  <hr>
  <p class="text-center">
    <button class="btn" v-if="selectedTripIndex === routeIndex" @click="setSelectedTripIndex(-1)">Hide Details</button>
    <button class="btn" v-else @click="setSelectedTripIndex(routeIndex)">View Details</button>
  </p>
</div>
</template>

<script>
// import DepartArriveOptions from './DepartArriveOptions'
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'

export default {
  name: 'trip-planner-results-summary',
  props: ['route', 'routeIndex'],
  mixins: [mixinCommon, mixinFilters],
  data () {
    return {
    }
  },
  computed: {
    router () { // get router params and query
      return this.$store.getters['tripPlanner/router'];
    },
    selectedTripIndex () {
      return parseInt(this.$store.getters['tripPlanner/selectedTripIndex'])
    }
  },
  watch: {
  },
  methods: {
    setSelectedTripIndex (index = -1) {
      console.log("setSelectedTripIndex", index)
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-trip-planner-trip-details' : 'trip-planner-trip-details',
          params: Object.assign(this.router.params, {tripIndex: index}),
          query : this.router.query,
        });
    },
    viewRouteDetails (mode = '', routeNo = '-') {
      if (mode.toLowerCase() === 'walk') {
        return;
      }
      let routeType = (mode.toLowerCase() === 'bus') ? 'bus' : 'lightrail'
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-routes-all' : 'routes-all',
          params: { routeOrLink: routeType, routeNo: routeNo}
        });
    },
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card {
  border-radius: 0;
  border-top-right-radius: 35px;
}
.line-no {
  margin-left: 3px;
  padding: 2px;
}
.icon-icon-triangle-right {
  font-size:75%;
}
.mode-icons {
  min-height: 60px;
}
.mode-details {
  padding:2px 5px 2px 2px;
  display: inline-block;
}
.mode-details:hover {
  background-color: #aaa;
  // color: #fff;
  cursor: pointer;
}
.mode-walk:hover {
  background-color: #fff;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerResultsSummary.vue